import { render, staticRenderFns } from "./WalletDelegationsHistoryList.vue?vue&type=template&id=26d34502&"
import script from "./WalletDelegationsHistoryList.vue?vue&type=script&lang=js&"
export * from "./WalletDelegationsHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./WalletDelegationsHistoryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports